const DATE_ONLY_FIELDS = new Set([
  'Geburtsdatum',
  'Vertragsbeginn',
  'Vertragsende',
  'Kuendigungszeitpunkt',
  'EingangUnterlagen',
  'AenderungTage',
  'AusweisGueltigBis',
  'VorzeitigeKuendigung',
  'exported',
])

const MINUTE_PRECISION_FIELDS = new Set(['BestaetigtAm'])

function dateKey(value) {
  if (!value) return ''
  const text = String(value).trim()
  const isoMatch = /^(\d{4})-(\d{2})-(\d{2})/.exec(text)
  if (isoMatch) return isoMatch.slice(1).join('-')

  const germanMatch = /^(\d{2})\.(\d{2})\.(\d{4})/.exec(text)
  if (germanMatch) return `${germanMatch[3]}-${germanMatch[2]}-${germanMatch[1]}`

  return text
}

function minuteKey(value) {
  if (!value) return ''
  const text = String(value).trim()
  const isoMatch = /^(\d{4}-\d{2}-\d{2})[T ](\d{2}):(\d{2})/.exec(text)
  if (isoMatch) {
    return `${isoMatch[1]} ${isoMatch[2]}:${isoMatch[3]}`
  }

  const germanMatch = /^(\d{2})\.(\d{2})\.(\d{4}) (\d{2}):(\d{2})/.exec(text)
  if (germanMatch) {
    return `${germanMatch[3]}-${germanMatch[2]}-${germanMatch[1]} ${germanMatch[4]}:${germanMatch[5]}`
  }

  return text
}

export function hasMeaningfulHistoryChange(field, oldValue, newValue) {
  if (DATE_ONLY_FIELDS.has(field)) {
    return dateKey(oldValue) !== dateKey(newValue)
  }
  if (MINUTE_PRECISION_FIELDS.has(field)) {
    return minuteKey(oldValue) !== minuteKey(newValue)
  }
  return true
}

export function formatHistoryValue(field, value) {
  if (value === null || value === undefined) return ''
  if (!DATE_ONLY_FIELDS.has(field)) return String(value)

  const key = dateKey(value)
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(key)
  return match ? `${match[3]}.${match[2]}.${match[1]}` : String(value)
}
